var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-goods-category bg-white"
  }, [_c('div', {
    staticClass: "flex shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 p-6 shadow-border-r mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Kategori Barang")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Kategori",
      "placeholder": "Nama Kategori"
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {}, [_c('Textarea', {
    attrs: {
      "type": "text",
      "label": "Deskripsi (optional)",
      "placeholder": "Masukan deskripsi"
    },
    model: {
      value: _vm.payloads.category_description,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "category_description", $$v);
      },
      expression: "payloads.category_description"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 p-6 mdmax:w-full mdmax:flex-auto"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Sub Kategori")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Terdapat Sub")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.subOptions,
      "default": "Tidak"
    },
    model: {
      value: _vm.hasSub,
      callback: function ($$v) {
        _vm.hasSub = $$v;
      },
      expression: "hasSub"
    }
  })], 1), _vm.hasSub === 'Ya' ? _c('div', {}, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Sub Ketgori",
      "placeholder": "Masukan sub ketegori gunakan tanda koma jika lebih dari satu"
    },
    model: {
      value: _vm.payloads.sub_categories,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "sub_categories", $$v);
      },
      expression: "payloads.sub_categories"
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "flex justify-end gap-6 p-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.save();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }